import { useTranslation } from 'react-i18next'
import { sweetAlertError } from '../sweetalert/Alert'

type Error = {
    status: number
    message: string
}

const CatchError = ({ status, message }: Error, callback?: () => void) => {
    if (status === 401) {
        const { t } = useTranslation('translation')
        sweetAlertError(t('error.session-expired')).then((res) => {
            if (res.isConfirmed) {
                callback?.()
            }
        })
    } else {
        sweetAlertError(message).then().catch()
    }
}

export default CatchError
